export default __webpack_public_path__ + "static/media/app.f438666a.svg";